// @flow

import React from "react";
import {scramble} from "./quiz/scramble";
import Wrong from "./quiz/Wrong";

type Question = {
  question: string,
  alternatives: string[],
  chapter: {
    title: string
  }};

type QuizState = {
  open: boolean,
  done: boolean,
  q: number,
  score: number,
  wrong: Question[]
};

type QuizProps = {questions: Question[], bookTitle: string};

export default class Quiz extends React.Component<QuizProps, QuizState> {

  state = {
    open: false,
    done: false,
    q: 0,
    score: 0,
    wrong: []
  };

  render() {
    return <div>
        <a onClick={this.start} className="main-button elm-bg">Start Quiz</a>
        {this.state.open && this.renderQuiz()}
      </div>;
  }

  renderQuiz() {
    return <div className="quiz-container" onClick={() => this.done()}>
      <div className="quiz" onClick={evt => evt.stopPropagation()}>
        <h2>{this.props.bookTitle} Quiz</h2>
        <br />
        {!this.state.done &&
          <h3>Q {this.state.q + 1}/{this.props.questions.length}</h3>
        }

        { !this.state.done ? this.renderQuestion() : this.renderResult() }
      </div>
    </div>
  }

  renderQuestion() {
    const question = this.state && this.props.questions[this.state.q];
    const scrambledAlternatives =
      question &&
      scramble(
        question.alternatives.map((a, idx) => ({ text: a, correct: idx === 0 }))
      );

    return (
      <div>
        <p>{question.question}</p>
        {scrambledAlternatives.map((a, idx) => (
          <button className="main-button elm-bg"
            key={idx}
            onClick={() => this.answer(a.correct)}
          >{a.text.replace(/`/g, "")}</button>
        ))}

        <br />
        <br />
        <p><em>This question is from the <strong>{question.chapter.title}</strong> chapter of {this.props.bookTitle}.</em></p>
      </div>
    );
  }

  renderResult() {
    return (
      <div>
        Your scored {this.state.score} out of {this.props.questions.length}.
          {this.state.wrong.length === 0
            ? " Well done. You got all the questions right!"
            : " Here are the things you didn't answer correctly:"
          }

          <ul>
          {this.state.wrong.map((question, idx) => (
            <Wrong question={question} key={idx} />
          ))}
          </ul>

        <button onClick={this.done} className="main-button elm-bg">Done</button>
      </div>
    );
  }

  answer = correct => {
    const delta = correct ? 1 : 0;
    const {questions} = this.props;
    let { wrong } = this.state;
    const done = this.state.q === questions.length - 1;

    if (!correct) wrong.push(questions[this.state.q]);

    if (done) {
      this.setState({
        score: this.state.score + delta,
        done: true,
        wrong
      });
    } else {
      this.setState({
        q: this.state.q + 1,
        score: this.state.score + delta,
        wrong
      });
    }
  };

  start = () => this.setState({ open: true, q: 0, score: 0, wrong: [] });

  done = () => this.setState({open: false, done: false});
}


// WEBPACK FOOTER //
// ./src/components/Quiz.js